// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Gr0Sv","content":"styles_content__rXdEL","row":"styles_row__frf8P","footer":"styles_footer__1wspi","phraseLength":"styles_phraseLength__3C43T"};